<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>

<style lang="scss">
.remark-container {
  text-align: center;
  padding: 0 20px;

  .remark-content {
    margin-bottom: 20px;
  }

  .el-button {
    padding: 10px 30px;
  }
}

.print-ag {
  text-align: center;
}

#instanceDetail .base-wrap {
  max-width: 600px;

  .base-item {
    position: relative;
    margin-bottom: 20px;
    line-height: 20px;
    float: left;
    width: 300px;
    padding-right: 20px;
    box-sizing: border-box;

    .label {
      display: inline-block;
      color: $text-placeholder;
      width: 90px;
      text-align: left;
      position: absolute;
      left: 0;
      top: 0;
    }

    .content {
      color: $text-primary;
      padding-left: 95px;
      min-height: 18px;
      max-width: 400px;

      .org-select-bar {
        margin-top: 10px;
      }
    }
  }

  .base-btn {
    margin-top: 100px;
    text-align: center;
  }
}

.item-line {
  max-width: 400px;

  .line-card-wrap {
    padding-top: 10px;

    .title {
      // font-weight: 400;
      margin-bottom: 10px;
    }

    .attach-form-wrap {
      padding: 10px;
      background-color: #f4f4f4;
      margin-bottom: 20px;
      border-radius: 6px;

      .attach-form-item {
        padding-left: 60px;
        position: relative;
        margin-bottom: 15px;

        .label {
          position: absolute;
          left: 0;
          line-height: 30px;
          color: #999;
        }

        .avatar-uploader {
          width: 82px;
          height: 64px;
          position: relative;
          // left: 60px;
          // top: 0;
        }

        .avatar-uploader .el-upload-dragger {
          width: 100%;
          height: 100%;
          border: none;
        }

        .img_keys_list {
          padding-top: 10px;

          a {
            display: block;
            line-height: 20px;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分文字以...显示 */
          }
          // a:hover {
          //   overflow: visible;
          //   white-space: inherit;
          // }
        }

        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          background-color: #fff;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 82px;
          height: 64px;
          line-height: 64px;
          text-align: center;
        }

        // .avatar {
        //   width: 82px;
        //   height: 64px;
        //   font-size: 30px;
        //   line-height: 64px;
        //   color: #409eff;
        //   display: block;
        // }

        .avatar-uploader .el-upload-list {
          position: absolute;
          width: 150px;
          height: 60px;
          left: 90px;
          top: 0;
          overflow: auto;
        }

        .el-upload-list::-webkit-scrollbar {
          /* 滚动条整体样式 */
          width: 5px; /* 高宽分别对应横竖滚动条的尺寸 */
          height: 1px;
        }

        .el-upload-list::-webkit-scrollbar-thumb {
          /* 滚动条里面小方块 */
          border-radius: 10px;
          background-color: skyblue;
          background-image:
            -webkit-linear-gradient(
              45deg,
              rgba(255, 255, 255, 0.2) 25%,
              transparent 25%,
              transparent 50%,
              rgba(255, 255, 255, 0.2) 50%,
              rgba(255, 255, 255, 0.2) 75%,
              transparent 75%,
              transparent
            );
        }

        .el-upload-list::-webkit-scrollbar-track {
          /* 滚动条里面轨道 */
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #ededed;
          border-radius: 10px;
        }

        .el-upload-list__item {
          font-size: 12px;
          margin-top: 5px;
          // line-height: 1.2;
        }
      }
    }

    .person {
      padding: 2px 0;
      position: relative;

      span.name {
        color: $text-primary;
      }

      p {
        margin-bottom: 10px;
        line-height: 20px;

        span.status {
          color: $color-success;
        }

        s.time {
          float: right;
        }
      }
    }

    .copy-reason {
      // padding-bottom: 20px;
      padding: 2px 0;
      // font-weight: 550;
    }

    .comment {
      padding: 2px 0;
      position: relative;
      // .comment_content{
      //   background-color: #f4f4f4;
      // }
      p {
        margin-bottom: 10px;
        line-height: 20px;

        span.username {
          color: $color-success;
          font-weight: 550;
        }

        s.time {
          float: right;
        }
      }
    }
  }
}

.split_line {
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 16px;
  font-size: 14px;

  i {
    margin-right: 4px;
    color: $color-primary;
    transform: rotate(90deg);
  }

  div.line {
    height: 1px;
    background-color: $border-color-base;
  }
}
</style>
<template>
  <div v-loading="pageLoading">
    <div class="instance-detail-wrap" id="instanceDetail">
      <!-- 审批信息 -->
      <div class="split_line">
        <i class="el-icon-price-tag"></i><span>基本信息</span>
        <div class="line"></div>
      </div>
      <div class="base-wrap clearfix">
        <div class="base-item">
          <em class="label">审批名称：</em>
          <div class="content">
            {{ instanceInfo.basic_info ? instanceInfo.basic_info.name : "" }}
          </div>
        </div>
        <div class="base-item">
          <em class="label">审批状态：</em>
          <div class="content">
            <el-tag
              v-if="instanceInfo.status"
              :type="
                approvalInstanceStatus.constMap.idMap[instanceInfo.status].class
              "
              size="mini">
              {{
                approvalInstanceStatus.constMap.idMap[instanceInfo.status].name
              }}
            </el-tag>
          </div>
        </div>
        <div class="base-item">
          <em class="label">发起人：</em>
          <div class="content">{{ instanceInfo.promoter }}</div>
        </div>
        <div class="base-item">
          <em class="label">发起时间：</em>
          <div class="content">{{ instanceInfo.start_time }}</div>
        </div>
        <div class="base-item">
          <em class="label">结束时间：</em>
          <div class="content">{{ instanceInfo.end_time || "--/--" }}</div>
        </div>
      </div>
      <!-- 表单信息 -->
      <div class="split_line">
        <i class="el-icon-price-tag"></i><span>表单信息</span>
        <div class="line"></div>
      </div>
      <template v-if="instanceFormType === 'applayReimbursement'">
        <applay-reimbursement-detail
          :formData="formData"
          :expenseTypes="expenseTypes"
          :companysMap="companysMap">
        </applay-reimbursement-detail>
      </template>
      <template
        v-else-if="
          [
            'adApplySpendMoney',
            'pdApplySpendMoney',
            'costApplySpendMoney',
            'fixedApplySpendMoney',
            'earnestApplySpendMoney',
            'taxApplySpendMoney',
            'insideTransferMoney',
          ].includes(instanceFormType)
        ">
        <applay-spend-money-detail
          :formData="formData"></applay-spend-money-detail>
      </template>
      <template v-else-if="instanceFormType === 'applayReserveFunds'">
        <applay-reserve-funds-detail
          :formData="formData"></applay-reserve-funds-detail>
      </template>
      <template v-else-if="instanceFormType === 'confirmCost'">
        <confirm-cost-detail :formData="formData"></confirm-cost-detail>
      </template>
      <template v-else-if="instanceFormType === 'clientRefund'">
        <client-refund-detail :formData="formData"> </client-refund-detail>
      </template>

      <!-- 审批流节点列表 -->
      <div class="split_line">
        <i class="el-icon-price-tag"></i><span>审批进度</span>
        <div class="line"></div>
      </div>
      <div class="item-line">
        <el-timeline>
          <el-timeline-item
            v-for="nodeItem in nodeList"
            size="large"
            :key="nodeItem.id"
            :icon="nodeItem.elLineIcon"
            :type="nodeItem.elLineType"
            :hide-timestamp="true">
            <el-card :body-style="cardBodyStyle" class="line-card-wrap">
              <h4 class="title">
                {{ approvalNodeTypes.constMap.idMap[nodeItem.type].name }}
              </h4>
              <!-- node类型非抄送 -->
              <template v-if="nodeItem.type != 3">
                <div
                  class="person"
                  v-for="item in nodeItem.task_list"
                  :key="item.name">
                  <span class="name">{{
                    item.username || item.user_open_id
                  }}</span>
                  <p>
                    <s class="time">{{ item.end_time }}</s>
                    <span
                      class="status"
                      v-if="approvalTaskStatus.constMap.idMap[item.status]">
                      {{ approvalTaskStatus.constMap.idMap[item.status].name }}
                    </span>
                  </p>
                </div>
              </template>
              <!-- node类型为抄送 -->
              <template v-if="nodeItem.type == 3">
                <div class="person">
                  抄送给：
                  <span
                    v-for="item in nodeItem.task_list"
                    :key="item.name"
                    style="padding-right: 10px;">{{ item.username || item.user_open_id }}</span>
                </div>
                <p
                  class="copy-reason"
                  v-if="nodeItem.user && nodeItem.user.name">
                  抄送发起人：{{ nodeItem.user.name }}
                </p>
                <p class="copy-reason" v-if="nodeItem.remark">
                  抄送原因：“ {{ nodeItem.remark }} ”
                </p>
                <p v-if="nodeItem.type === 3" class="copy-reason"
                  style="padding-bottom: 10px;">
                  日期： {{ nodeItem.end_time }}
                </p>
              </template>

              <div
                v-if="
                  nodeItem.attachFormRole != 'hidden' &&
                  nodeItem.attachForm &&
                  nodeItem.attachForm.length > 0
                "
                class="attach-form-wrap">
                <div
                  class="attach-form-item"
                  v-for="attachFormItem in nodeItem.attachForm"
                  :key="nodeItem.id + attachFormItem.field">
                  <span class="label">{{ attachFormItem.title }}：</span>
                  <template v-if="attachFormItem.formType === 'select'">
                    <el-select
                      v-model="attachFormItem.value"
                      :placeholder="attachFormItem.placeholder"
                      style="width: 100%;"
                      :disabled="nodeItem.attachFormRole === 'readonlny'"
                      size="mini">
                      <el-option
                        v-for="item in attachFormItem.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else-if="attachFormItem.formType === 'input'">
                    <el-input
                      v-model="attachFormItem.value"
                      size="mini"
                      :disabled="nodeItem.attachFormRole === 'readonlny'"
                      style="width: 100%;"
                      :placeholder="attachFormItem.placeholder">
                    </el-input>
                  </template>
                  <template v-else-if="attachFormItem.formType === 'number'">
                    <el-input-number
                      size="mini"
                      :min="0"
                      :max="999999999"
                      v-model="attachFormItem.value"
                      :disabled="nodeItem.attachFormRole === 'readonlny'"
                      style="width: 100%;"></el-input-number>
                  </template>
                  <template v-else-if="attachFormItem.formType === 'datetime'">
                    <el-date-picker
                      v-model="attachFormItem.value"
                      type="datetime"
                      format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :placeholder="attachFormItem.placeholder"
                      :disabled="nodeItem.attachFormRole === 'readonlny'"
                      style="width: 100%;"
                      size="mini">
                    </el-date-picker>
                  </template>
                  <template v-else-if="attachFormItem.formType === 'upload'">
                    <el-upload
                      ref="upload"
                      drag
                      :disabled="nodeItem.attachFormRole === 'readonlny'"
                      class="avatar-uploader"
                      :file-list="attachFormItem.value"
                      :action="`/api/base/upload?az_tk=${token}`"
                      :on-remove="
                        (file, fileList) =>
                          handleRemove(file, fileList, attachFormItem)
                      "
                      accept=".jpg,.jpeg,.png,.pdf"
                      :on-exceed="handleExceed"
                      :limit="5"
                      :on-success="
                        (res, file, fileList) =>
                          handleAvatarSuccess(
                            res,
                            file,
                            fileList,
                            attachFormItem
                          )
                      "
                      :before-upload="(file) => beforeAvatarUpload(file)">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="img_keys_list">
                      <a
                        style="color: #2f78ff;"
                        v-for="img in attachFormItem.value"
                        :key="img.key"
                        :href="`/api/base/download?key=${img.key}`"
                        target="_blank">{{ img.name }}&nbsp;&nbsp;</a>&nbsp;
                    </div>
                  </template>
                </div>
                <div
                  class="attach-form-item"
                  v-if="nodeItem.attachFormRole === 'edit'">
                  <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="actionAttachFormHandler(nodeItem.attachForm)"
                    title="已检查各项信息填写无误，确认提交？">
                    <el-button
                      slot="reference"
                      type="primary"
                      size="mini"
                      plain
                      style="width: 100%;"
                      :loading="savePageLoading">
                      保存
                    </el-button>
                  </el-popconfirm>
                </div>
              </div>
              <div
                class="attach-form-wrap"
                v-if="
                  nodeItem.originalFormOperate == 2 &&
                  nodeItem.originalFormOperateRole === 'edit'
                ">
                <div class="attach-form-item" style="margin-bottom: 0;">
                  <span class="label">表单操作:</span>
                  <div style="height: 28px; line-height: 28px;">
                    <el-link type="primary" :underline="false" @click="editForm">编辑表单
                    </el-link>
                  </div>
                </div>
              </div>
              <div class="attach-form-wrap" v-if="nodeItem.modify_log_show">
                <div class="attach-form-item" style="margin-bottom: 0;">
                  <span class="label" style="top: -6px;">操作记录:</span>
                  <div v-for="task in nodeItem.task_list" :key="task.id">
                    <p
                      v-if="task.modify_log"
                      style="
                        word-wrap: break-word;
                        word-break: break-all;
                        overflow: hidden;
                        white-space: pre-line;
">
                      {{ task.username }}:{{ task.modify_log }}
                    </p>
                  </div>
                </div>
              </div>
            </el-card>
            <template>
              <el-card
                :body-style="cardBodyStyle"
                class="line-card-wrap"
                style="margin-top: 10px;"
                v-for="commentItem in nodeItem.comments"
                :key="commentItem.id">
                <div class="comment">
                  <p>
                    <s class="time">{{ commentItem.created_at }}</s>
                    <span class="username">
                      {{ commentItem.username }}
                    </span>
                  </p>
                  <p class="comment_content">
                    评论了：“ {{ commentItem.content }} ”
                  </p>

                  <p
                    class="comment_content"
                    v-if="
                      commentItem.img_keys && commentItem.img_keys.length > 0
                    ">
                    附件：
                    <template v-for="img in commentItem.img_keys">
                      <a
                        style="color: #2f78ff;"
                        :key="img.key"
                        :href="`/api/base/download?key=${img.key}`"
                        target="_blank">{{ img.name }}&nbsp;&nbsp;</a>&nbsp;
                    </template>
                  </p>
                </div>
              </el-card>
            </template>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="base-btn">
        <!-- 1同意2拒绝 -->
        <el-button
          :disabled="controlBtnIsLoading"
          size="small"
          type="primary"
          @click="drawer = true">
          评论</el-button>
        <el-button
          :disabled="controlBtnIsLoading"
          size="small"
          type="success"
          @click="$refs['copyDrawerRef'].$emit('openDrawer')">
          抄送</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="actions.allow"
          :disabled="controlBtnIsLoading"
          @click="actionHandler(2)">同意</el-button>
        <el-button
          :disabled="controlBtnIsLoading"
          type="danger"
          size="small"
          v-if="actions.deny"
          @click="actionHandler(3)">
          拒绝</el-button>
        <el-button
          :disabled="controlBtnIsLoading"
          type="danger"
          size="small"
          v-if="actions.withdraw"
          @click="cancleActionHandler">
          撤回</el-button>
      </div>
      <applay-reimbursement ref="applayReimbursement" @refresh="handleRefresh">
      </applay-reimbursement>
      <applay-reserve-funds ref="applayReserveFunds" @refresh="handleRefresh">
      </applay-reserve-funds>
      <ad-apply-spend-money ref="adApplySpendMoney" @refresh="handleRefresh">
      </ad-apply-spend-money>
      <pd-apply-spend-money ref="pdApplySpendMoney" @refresh="handleRefresh">
      </pd-apply-spend-money>
      <cost-apply-spend-money
        ref="costApplySpendMoney"
        @refresh="handleRefresh">
      </cost-apply-spend-money>
      <earnest-apply-spend-money
        ref="earnestApplySpendMoney"
        @refresh="handleRefresh">
      </earnest-apply-spend-money>
      <fixed-apply-spend-money
        ref="fixedApplySpendMoney"
        @refresh="handleRefresh">
      </fixed-apply-spend-money>
      <tax-apply-spend-money ref="taxApplySpendMoney" @refresh="handleRefresh">
      </tax-apply-spend-money>
      <confirm-cost ref="confirmCost" @refresh="handleRefresh"> </confirm-cost>
      <client-refund
        ref="clientRefund"
        @refresh="handleRefresh"></client-refund>
      <inside-transfer-money
        ref="insideTransferMoney"
        @refresh="handleRefresh"></inside-transfer-money>
    </div>
    <div class="print-ag">
      <el-button type="primary" size="small" plain @click="handlePrint">预览
      </el-button>
      <el-button
        type="primary"
        size="small"
        plain
        v-if="
          [
            'adApplySpendMoney',
            'pdApplySpendMoney',
            'costApplySpendMoney',
            'fixedApplySpendMoney',
            'earnestApplySpendMoney',
            'insideTransferMoney'
          ].includes(instanceFormType)
        "
        @click="handlePrintSpendMoney">打印付款通知单
      </el-button>
    </div>
    <el-drawer
      title="评论"
      :visible.sync="drawer"
      :before-close="hanldeDrawerClose">
      <div class="remark-container">
        <div class="remark-content">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入评论内容"
            v-model="comment">
          </el-input>
        </div>
        <div
          class="upload-label"
          style="text-align: left; padding-bottom: 20px;">
          上传附件：
        </div>
        <div class="invoice-wrap1">
          <el-upload
            ref="upload"
            drag
            class="avatar-uploader"
            :file-list="img_keys"
            accept=".jpg,.jpeg,.png,.pdf"
            :action="`/api/base/upload?az_tk=${token}`"
            :on-remove="handleRemoveAccessory"
            :on-exceed="handleExceedAccessory"
            :limit="5"
            :on-success="
              (res, file, fileList) =>
                handleAvatarSuccessAccessory(res, file, fileList)
            "
            :before-upload="(file) => beforeAvatarUploadAccessory(file)">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <el-button
          type="primary"
          @click="handlePostComment"
          :loading="commantLoading">
          评论</el-button>
      </div>
    </el-drawer>
    <copy-drawer
      @refreshIns="() => initPage()"
      :id="id"
      ref="copyDrawerRef"></copy-drawer>
  </div>
</template>
<script>
import {
  getApprovalInstanceDetail,
  approvalInstanceTask,
  cancelInstanceTask,
  getExpenseTypeList,
  approvalInstanceAttachFormTask,
  postComment,
} from '@/api/approval';
import {
  attachFormConfig,
  approvalInstanceStatus,
  approvalNodeStatus,
  approvalTaskStatus,
  coins,
  approvalNodeTypes,
  approvalInstanceType,
} from '@/const';
import { getCompanyList } from '@/api/company';
import { getProjects } from '@/api/project';
import { formatNum } from '@/utils/toTx'
import applayReimbursementDetail from './applayReimbursementDetail';
import applaySpendMoneyDetail from './applaySpendMoneyDetail';
import applayReserveFundsDetail from './applayReserveFundsDetail';
import confirmCostDetail from './confirmCostDetail';
import applayReimbursement from '../instanceForm/applayReimbursement';
import applayReserveFunds from '../instanceForm/applayReserveFunds';
import adApplySpendMoney from '../instanceForm/adApplySpendMoney';
import pdApplySpendMoney from '../instanceForm/pdApplySpendMoney';
import costApplySpendMoney from '../instanceForm/costApplySpendMoney';
import earnestApplySpendMoney from '../instanceForm/earnestApplySpendMoney';
import fixedApplySpendMoney from '../instanceForm/fixedApplySpendMoney';
import confirmCost from '../instanceForm/confirmCost';
import clientRefund from '../instanceForm/clientRefund';
import taxApplySpendMoney from '../instanceForm/taxApplySpendMoney.vue';
import insideTransferMoney from '../instanceForm/insideTransferMoney.vue';
import clientRefundDetail from './clientRefundDetail';
import copyDrawer from './components/copyDrawer.vue';
import _ from 'lodash';
export default {
  name: 'instance-detail',
  data() {
    return {
      options: [],
      drawer: false,
      commantLoading: false,
      comment: '', // 评论
      value: '',
      id: this.$route.query.id,
      approvalNodeStatus,
      approvalTaskStatus,
      approvalInstanceStatus,
      approvalInstanceType,
      coins, // 币种
      expenseTypes: [],
      img_keys: [],
      approvalNodeTypes,
      pageLoading: true,
      savePageLoading: false,
      instanceInfo: {}, // 实力基本信息
      formData: {}, // 表单信息
      nodeList: [], // 审批节点信息
      companysMap: {},
      projectMap: {},
      cardBodyStyle: {
        padding: '0 20px',
      },
      actions: {
        allow: false,
        deny: false,
        withdraw: false,
        taskId: '',
      },
      formDialogType: null,
      controlBtnIsLoading: false,
      attactFormPopConfirmBtn: false,
    };
  },
  components: {
    confirmCostDetail,
    confirmCost,
    clientRefund,
    clientRefundDetail,
    applayReimbursementDetail,
    applaySpendMoneyDetail,
    applayReserveFundsDetail,
    applayReimbursement,
    applayReserveFunds,
    adApplySpendMoney,
    pdApplySpendMoney,
    costApplySpendMoney,
    fixedApplySpendMoney,
    earnestApplySpendMoney,
    taxApplySpendMoney,
    copyDrawer,
    insideTransferMoney
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    my_user_open_id() {
      return this.$store.state.user.open_id;
    },
    instanceFormType() {
      if (this.instanceInfo.basic_info) {
        const mapItem = this.approvalInstanceType.constMap.idMap[this.instanceInfo.basic_info.type];
        return mapItem.enName;
      } else {
        return '';
      }
    },
  },
  methods: {
    hanldeDrawerClose() {
      this.img_keys = [];
      this.comment = '';
      this.drawer = false;
    },
    handleRemoveAccessory(file, fileList) {
      console.log(file, fileList);
      this.img_keys = fileList;
    },
    handleExceedAccessory(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error',
      });
    },
    handleAvatarSuccessAccessory(res, file, fileList) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
      } else {
        this.img_keys.push({ name: file.name, key: res.data.key });
        console.log(this.img_keys, 'shag');
        this.$message({
          message: '上传成功',
          type: 'success',
        });
      }
    },
    beforeAvatarUploadAccessory(file) {
      console.log(file);
      console.log(this.fileList, 'fileList');
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true;
    },
    // 提交评论
    handlePostComment() {
      console.log(this.comment, '评论');
      if (!this.comment) {
        this.$message.warning('请输入评论内容');
        return;
      }
      this.commantLoading = true;
      postComment(this.id, this.comment, this.img_keys)
        .then((res) => {
          if (res.code != 0) {
            return this.$message.error(res.message);
          }
          this.drawer = false;
          this.img_keys = [];
          this.comment = '';
          this.$message.success('评论提交成功');
          this.initPage();
          // this.$router.go(0)
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.commantLoading = false;
        });
    },
    // 公共数据
    handleCommon() {
      const { basic_info } = this.instanceInfo;
      let base = [
        {
          title: '发起人',
          content: this.instanceInfo.promoter,
        },
        {
          title: '审批类型',
          content: basic_info.name,
        },
        {
          title: '发起时间',
          content: this.instanceInfo.start_time,
        },
        {
          title: '结束时间',
          content: this.instanceInfo.end_time || '--/--',
        },
        {
          title: '审批状态',
          content:
            approvalInstanceStatus.constMap.idMap[this.instanceInfo.status]
              .name,
        },
        {
          title: '审批类型',
          content: basic_info.name,
        },
      ];
      let approve = [];
      for (let i = 0; i < this.nodeList.length; i++) {
        let task_node = {
          id: this.nodeList[i].id,
          task_list: [],
        };
        if (!this.nodeList[i].task_list) continue;
        this.nodeList[i].task_list.forEach((task) => {
          task_node.task_list.push({
            id: task.id,
            username: task.username,
            status: approvalTaskStatus.constMap.idMap[task.status].name,
            end_time: task.end_time,
          });
        });
        approve.push(task_node);
      }
      return { base, approve };
    },
    // 1.报销
    handleReimbursement(form) {
      console.log(form, 'form');
      let applayReimbursement = [
        {
          name: '报销标题',
          content: form.title,
        },
        {
          name: '报销人',
          content: form.real_user_info.name,
        },
        {
          name: '公司主体',
          content: this.companysMap[form.owner_company_id].name || '--/--',
        },
        {
          name: '项目名称',
          content: form.owner_project_info.name,
        },
        {
          name: '总金额',
          content: form.sum_money,
        },
        {
          name: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
      ];
      let expenseTypesMap = {};
      this.expenseTypes.forEach((item) => {
        expenseTypesMap[item.id] = item;
      });
      let applayReimbursementTable1 = form.detail.map((item) => {
        return {
          name: expenseTypesMap[item.type]
            ? expenseTypesMap[item.type].name
            : '--/--',
          money: item.money,
          sum_tax_amount: item.sum_tax_amount || '-/-',
          created_at: item.created_at,
          error_msg: item.error_msg || '-/-',
          remark: item.remark,
        };
      });
      // 表单2
      let list = this.expenseTypes.map((item) => {
        return {
          id: item.id,
          name: item.name,
          money: 0,
        };
      });

      form.detail.forEach((item) => {
        list.forEach((typeItem) => {
          if (item.type == typeItem.id) {
            typeItem.money += item.money;
          }
        });
      });
      let applayReimbursementTable2 = list.filter((item) => {
        return item.money != 0;
      });

      console.log(this.nodeList, 'node_list');

      let printFileData = {
        applayReimbursement,
        applayReimbursementTable1,
        applayReimbursementTable2,
      };
      return printFileData;
    },
    // 2用款申请
    handleApplySpendMoney(form) {
      let applySpendMoney = [
        {
          title: '用款事由',
          content: form.title,
        },
        {
          // 提出来
          title: '费用部门',
          content: form.department_info ? form.department_info.name : '-/-',
        },
        {
          title: '我方公司',
          content: form.owner_company_info
            ? form.owner_company_info.name
            : '--/--',
        },
        {
          title: '对方公司',
          content: form.other_company_info
            ? form.other_company_info.name
            : '--/--',
        },
        {
          title: '对方银行',
          content: form.other_bank_info ? form.other_bank_info.name : '--/--',
        },
        {
          title: '对方开户行',
          content: form.other_bank_info
            ? form.other_bank_info.address
            : '--/--',
        },
        {
          title: '对方银行账号：',
          content: form.other_bank_info ? form.other_bank_info.number : '--/--',
        },
        {
          title: '最晚付款日期：',
          content: form.last_pay_time || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '总金额',
          content: form.sum_money,
        },
        {
          title: '备注信息',
          content: form.remark,
        },
      ];
      return { applySpendMoney };
    },
    // 3.备用金
    handleApplayReserveFunds(form) {
      let applayReserveFunds = [
        {
          title: '申请事由',
          content: form.title,
        },
        {
          title: '收款人',
          content: form.receive_name || '--/--',
        },
        {
          title: '开户行',
          content: form.receive_bank_type || '--/--',
        },
        {
          title: '收款账号',
          content: form.receive_bank_no || '--/--',
        },
        {
          title: '最晚归还',
          content: form.back_time || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '总金额',
          content: form.sum_money,
        },
      ];

      return { applayReserveFunds };
    },
    // 7确认费用
    handleConfirmCost(form) {
      let confirmCost = [
        {
          title: '费用事由',
          content: form.title,
        },
        {
          title: '我方公司',
          content: form.owner_company_info
            ? form.owner_company_info.name
            : '--/--',
        },
        {
          title: '对方公司',
          content: form.other_company_info
            ? form.other_company_info.name
            : '--/--',
        },
        {
          title: '入账时间',
          content: form.entry_pay_time ? form.entry_pay_time : '--/--',
        },
        {
          title: '税前金额',
          content: form.sum_money || '--/--',
        },
        {
          title: '进账税额',
          content: form.income_tax_money || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '备注信息',
          content: form.remark,
        },
      ];
      return { confirmCost };
    },
    handlePrint() {
      const { form } = this.instanceInfo;
      let printFileData = {
        instanceFormType: this.instanceFormType,
      };
      const commonData = this.handleCommon(form);
      if (this.instanceFormType == 'applayReimbursement') {
        // 1.报销
        let reimbursement = this.handleReimbursement(form);
        printFileData = {
          ...printFileData,
          ...commonData,
          ...reimbursement,
        };
      } else if (
        [
          'adApplySpendMoney',
          'pdApplySpendMoney',
          'costApplySpendMoney',
          'fixedApplySpendMoney',
          'earnestApplySpendMoney',
          'clientRefund',
          'taxApplySpendMoney',
          'insideTransferMoney'
        ].includes(this.instanceFormType)
      ) {
        // 用款申请
        let applySpendMoney = this.handleApplySpendMoney(form);
        printFileData = {
          ...printFileData,
          ...commonData,
          ...applySpendMoney,
        };
      } else if (this.instanceFormType === 'applayReserveFunds') {
        // 备用金
        let applayReserveFunds = this.handleApplayReserveFunds(form);
        printFileData = {
          ...printFileData,
          ...commonData,
          ...applayReserveFunds,
        };
      } else if (this.instanceFormType === 'confirmCost') {
        let confirmCost = this.handleConfirmCost(form);
        printFileData = {
          ...printFileData,
          ...commonData,
          ...confirmCost,
        };
      }
      sessionStorage.setItem('ag-print', JSON.stringify(printFileData));
      this.$router.push('/approval/instance/print');
    },
    handlePrintSpendMoney() {
      const { form } = this.instanceInfo;
      let printFileData = {
        department: this.instanceInfo.user_info.department.name,
        created_at: this.instanceInfo.created_at,
        other_company: form.other_company_info.name,
        other_company_bank: form.other_bank_info.name,
        other_company_number: form.other_bank_info.number,
        content: form.title,
        money: form.sum_money,
        coin_type: form.coin_type,
        coin_name: coins.constMap.idMap[form.coin_type].name,
        coin_Enname: coins.constMap.idMap[form.coin_type].EnName,
      };

      sessionStorage.setItem(
        'ag-print-spend-money',
        JSON.stringify(printFileData)
      );
      this.$router.push('/approval/instance/print-spend-money');
    },

    editForm() {
      console.log(this.formData, 'formdata');
      switch (this.formDialogType) {
        case 1:
          this.$refs['applayReimbursement'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 2:
          this.$refs['applayReserveFunds'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 3:
          this.$refs['adApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 4:
          this.$refs['pdApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 5:
          this.$refs['costApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 6:
          this.$refs['fixedApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 7:
          this.$refs['confirmCost'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 8:
          this.$refs['earnestApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 9:
          this.$refs['clientRefund'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 10:
          this.$refs['taxApplySpendMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        case 11:
          this.$refs['insideTransferMoney'].$emit(
            'edit',
            this.actions.taskId,
            this.formData
          );
          break;
        default:
          return;
      }
    },
    handleRefresh() {
      this.initPage();
    },
    cancleActionHandler() {
      this.controlBtnIsLoading = true;
      console.log(this.actions.taskId);
      cancelInstanceTask(this.id)
        .then((res) => {
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('操作成功');
          this.initPage();
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.controlBtnIsLoading = false;
        });
    },
    actionHandler(actionStatus) {
      if (!this.actions.taskId) return this.$message.error('任务错误');
      this.controlBtnIsLoading = true;
      approvalInstanceTask(this.actions.taskId, actionStatus)
        .then((res) => {
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('操作成功');
          this.initPage();
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.controlBtnIsLoading = false;
        });
    },

    // 附属表单上传凭证
    handleRemove(file, fileList, attachFormItem) {
      console.log(file, fileList);
      attachFormItem.value = fileList;
      console.log(value, 'value');
    },
    handleExceed(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error',
      });
    },
    handleAvatarSuccess(res, file, fileList, attachFormItem) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
      } else {
        console.log(attachFormItem.value, '1111111');
        attachFormItem.value.push({ name: file.name, key: res.data.key });
        this.$message({
          message: '上传成功',
          type: 'success',
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true;
    },
    actionAttachFormHandler(attachForm) {
      const formData = {};
      console.log(attachForm);
      for (const attachItem of attachForm) {
        formData[attachItem.field] = attachItem.value;
      }
      console.log(formData);
      if (formData.money === 0) {
        return this.$message.warning(
          '付款金额为0不能提交，如有疑问请联系研发人员'
        );
      }
      // 放在接口前面，保证一次接口请求后可以正常进行下次
      if (this.attactFormPopConfirmBtn) return;
      this.attactFormPopConfirmBtn = true;
      this.savePageLoading = true;
      approvalInstanceAttachFormTask(this.actions.taskId, formData)
        .then((res) => {
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('操作成功');
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.savePageLoading = false;
          this.attactFormPopConfirmBtn = false;
        });
    },

    resetData() {
      this.actions = {
        allow: false,
        deny: false,
        withdraw: false,
        editAttachForm: false,
        taskId: '',
      };
    },
    async initPage() {
      this.pageLoading = true;
      this.resetData();
      const [companyRes, customerRes, expenseRes] = await Promise.all([
        getCompanyList({ page: 1, per_page: 10000, type: 1 }),
        getProjects({ page: 1, per_page: 20000 }),
        getExpenseTypeList({ page: 1, per_page: 20000 }),
      ]);
      let companys = [];
      let projects = [];
      const companysMap = {};
      const projectMap = {};
      if (
        companyRes.code === 0 &&
        companyRes.data &&
        Array.isArray(companyRes.data.items)
      ) companys = companyRes.data.items;
      if (
        customerRes.code === 0 &&
        customerRes.data &&
        Array.isArray(customerRes.data.items)
      ) projects = customerRes.data.items;
      if (
        expenseRes.code === 0 &&
        expenseRes.data &&
        Array.isArray(expenseRes.data.items)
      ) this.expenseTypes = expenseRes.data.items;
      companys.forEach((item) => {
        companysMap[item.id] = item;
      });
      projects.forEach((item) => {
        projectMap[item.id] = item;
      });
      this.companysMap = companysMap;
      this.projectMap = projectMap;
      getApprovalInstanceDetail(this.id)
        .then(async (res) => {
          console.log('res', res);
          if (res.code != 0 || !res.data) throw new Error(res.message);
          this.instanceInfo = res.data;
          // 如果实例状态为审批中，并且发起人id等于登录id，则可撤回
          if (
            res.data.user_open_id == this.my_user_open_id &&
            res.data.status == 1
          ) {
            this.actions.withdraw = true;
          }
          this.formData = res.data.form || {};
          this.formData.format_sum_money = formatNum(this.formData.sum_money);
          this.formDialogType = res.data.basic_info.type;
          console.log('res.data.node_list', res.data.node_list);
          let isApprovaEnd = true;

          const nodeList = [];
          for (const item of res.data.node_list || []) {
            const nodeType = approvalNodeTypes.constMap.idMap[item.type];
            const nodeStatus = approvalNodeStatus.constMap.idMap[item.status];
            const elLineIcon = nodeStatus.elLineIcon;
            const elLineType = nodeStatus.elLineType;
            // if(instanceStatus != )isApprovaEnd

            if (!['APPROVED'].includes(nodeStatus.enName)) {
              isApprovaEnd = false;
            }
            /** 处理返回的attachForm数据，展示在页面上 */
            const instance_attr_info = item.instance_attr_info || {};
            const attachForm = [];
            let attachFormRole = 'readonlny'; // readonlny edit hidden
            let originalFormOperateRole = 'readonlny';
            const originalFormOperate =
              item.basic_node_info.properties.originalFormOperate || 1;
            try {
              if (['WAITING'].includes(nodeStatus.enName)) throw new Error('未审批节点不展示');
              const attachFormOrigin =
                item.basic_node_info.properties.attachForm || [];
              for (const attachItem of attachFormOrigin) {
                try {
                  let attachItemNew = _.cloneDeep(
                    attachFormConfig.constMap.idMap[attachItem.name]
                  );
                  if (nodeStatus.enName != 'PENDING') {
                    attachItemNew.disabled = true;
                    originalFormOperateRole = 'readonlny';
                    attachFormRole = 'readonlny';
                  }
                  if (attachItemNew.formType === 'select') {
                    console.log(
                      'attachItemNew.opetionGenerator',
                      attachItemNew.opetionGenerator
                    );
                    attachItemNew.options =
                      // eslint-disable-next-line no-await-in-loop
                      (await attachItemNew.opetionGenerator()) || [];
                    console.log('attachItemNew.options', attachItemNew.options);
                  }

                  attachItemNew.value =
                    instance_attr_info[attachItemNew.field] ||
                    attachItemNew.value;
                  attachForm.push(attachItemNew);
                } catch (err) {
                  /** */
                }
              }
            } catch (err) {
              /** */
            }
            // 修改记录是否显示 需要放在下面处理task_list数据前，使用后端返回的第一手数据
            if (item.task_list && item.task_list.length > 0) {
              item.modify_log_show = item.task_list.some((taskItem) => {
                return !!taskItem.modify_log;
              });
            } else {
              item.modify_log_show = false;
            }

            // 设置允许拒绝按钮审批权限(审批中)
            if (
              nodeStatus.enName == 'PENDING' &&
              Array.isArray(item.task_list)
            ) {
              item.task_list.forEach((taskItem) => {
                // zhangbo 1.任务中有用户id等于登录的id时，说明你有编辑权限，
                if (taskItem.user_open_id != this.my_user_open_id) return;
                attachFormRole = 'edit';
                originalFormOperateRole = 'edit';
                // 2.任务状态为该你审批中时，则显示操作按钮
                const taskStatus =
                  approvalTaskStatus.constMap.idMap[taskItem.status];
                if (taskStatus.enName === 'PENDING') {
                  this.actions.allow = true;
                  this.actions.deny = true;
                  this.actions.taskId = taskItem.id;
                }
              });
            }

            if (
              nodeStatus.enName == 'WAITING' &&
              Array.isArray(item.approver)
            ) {
              const task_list = item.approver.map((approverItem, index) => {
                return {
                  username: approverItem.username,
                  user_open_id: approverItem.user_open_id,
                  status: 0,
                  id: 'abc' + index,
                };
              });
              if (Array.isArray(item.task_list) && item.task_list.length <= 0) item.task_list = task_list;
            }
            if (nodeType.enName === 'start') {
              const task_list = [
                {
                  username: this.instanceInfo.promoter,
                  status: item.status,
                  id: 'aaaa',
                  end_time: item.end_time,
                },
              ];
              item.task_list = task_list;
            }

            const res = {
              elLineIcon,
              elLineType,
              attachForm,
              attachFormRole,
              originalFormOperate,
              originalFormOperateRole,
              ...item,
            };

            nodeList.push(res);
          }

          console.log('isApprovaEnd', isApprovaEnd);
          const endNodeStatus = approvalNodeStatus.constMap.idMap[isApprovaEnd ? '2' : '0'];
          nodeList.push({
            elLineIcon: endNodeStatus.elLineIcon,
            elLineType: endNodeStatus.elLineType,
            type: 0, // end
          });
          this.nodeList = nodeList;
          console.log(nodeList, 'nodelist');
        })
        .catch((err) => {
          console.error(err);
          /** 注释 */
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
  async created() {
    this.initPage();
  },
};
</script>
